import { render, staticRenderFns } from "./ticket-type-restaurant.vue?vue&type=template&id=44419e71&scoped=true"
import script from "./ticket-type-restaurant.vue?vue&type=script&lang=js"
export * from "./ticket-type-restaurant.vue?vue&type=script&lang=js"
import style0 from "./ticket-type-restaurant.vue?vue&type=style&index=0&id=44419e71&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44419e71",
  null
  
)

export default component.exports